import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';
import { MERCURE_OPENING_STATUS } from '~/const/orders';

const buildHomeUrl = () => '/';

const CgvType = {
  PRO: 'cgv-pro',
  MARKETPLACE: 'cgv-marketplace',
  DEFAULT: 'cgv'
};

const buildCategoryUrl = (locale, slug, hash) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);

const buildProductUrl = (locale, slug, reference) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");

const buildStaticUrl = (locale, slug, oldVersion) => {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};

const buildSearchUrl = (locale, query) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);

const buildEditoUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);

const buildMyAccountUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/user");

const buildFaqUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);

const buildContactFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);

const buildReturnFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);

const buildCgvUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legale/").concat(CgvType[page] || CgvType.DEFAULT);

const buildCartUrl = function buildCartUrl(locale) {
  if (this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[locale.iso]) {
    return "/".concat(locale.market, "/").concat(locale.language, "/cart");
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/panier.html");
};

export const buildUrlForCheckout = {
  buildHomeUrl,
  buildProductUrl,
  buildCartUrl,
  buildMyAccountUrl,
  buildCgvUrl
};
export default {
  methods: {
    buildCategoryUrl,
    buildEditoUrl,
    buildProductUrl,
    buildStaticUrl,
    buildSearchUrl,
    buildFaqUrl,
    buildContactFormUrl,
    buildReturnFormUrl,
    buildCartUrl
  }
};